import React, { createElement, memo, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { MetaTag } from "~/generated";

export type MetaTagUnserialized = {
  tag: string;
  attributes?: unknown;
  children?: string;
};

export interface MetaTagsProps {
  def: (MetaTag | MetaTagUnserialized)[];
}

const MetaTags_ = ({ def }: MetaTagsProps) => {
  const parsedMetatags = useMemo<{ tag: string; props: object }[]>(
    () =>
      def
        .map(({ tag, attributes, children }, key) => {
          try {
            const parsedMetaAttribute =
              typeof attributes !== "undefined"
                ? typeof attributes === "string"
                  ? JSON.parse(attributes as string)
                  : attributes
                : {};
            // stringify sub keys again
            const partiallyStringifierMetaAttributes = Object.keys(
              parsedMetaAttribute
            ).reduce(
              (acc, keyName) => ({
                ...acc,
                [keyName]:
                  typeof parsedMetaAttribute[keyName] === "object"
                    ? JSON.stringify(parsedMetaAttribute[keyName])
                    : parsedMetaAttribute[keyName],
              }),
              {}
            );
            return {
              tag,
              props: {
                ...partiallyStringifierMetaAttributes,
                key,
                children,
              },
            };
          } catch (e) {
            console.error(`Error parsing metatags!`, e);
            return false;
          }
        })
        .filter((v) => v !== false) as { tag: string; props: object }[],
    [def]
  );

  return (
    <Helmet>
      {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
      {parsedMetatags.map(({ tag, props }) => createElement(tag!, props))}
    </Helmet>
  );
};

export const MetaTags = memo(MetaTags_);
